import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import Authmiddleware from "routes/AuthMiddleWare";
import GlobalContext from "context/GlobalContext";

const App = () => {
  return (
    <GlobalContext>
      <BrowserRouter>
        {/* Suspense boundary for lazy-loaded components */}
        <Suspense fallback={<div>{null}</div>}>
          <Authmiddleware />
        </Suspense>
      </BrowserRouter>
    </GlobalContext>
  );
};

export default App;
